export const maxLengthWeight = (value: any, country?: string) => {
  if (Number(value) >= 150) return 3;
  else if (Number(value.split(country === "MY" ? "." : ",")[0]) < 10) return 4;
  else if (Number(value.split(country === "MY" ? "." : ",")[0]) < 100) return 5;
  return 6;
};
